<template>
  <div class="slot-list-container">
    <div class="choose-options">
      <el-select v-model="searchInfo.status" placeholder="请选择状态" clearable>
        <el-option
          v-for="item in statusOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-input
        v-model="searchInfo.keyword"
        placeholder="请输入编号或槽值"
        clearable
      />
      <el-button type="three" @click="getLists('search')">筛选</el-button>
      <el-button type="three" @click="resetSearchInfo">重置</el-button>
    </div>
    <el-button type="three" size="medium" @click="addSlot('添加')"
      >添加槽值</el-button
    >
    <div class="slot-lists">
      <el-empty :image-size="200" v-if="slotLists.length <= 0"></el-empty>
      <div
        class="slot-container"
        v-for="(item, index) in slotLists"
        :key="index"
      >
        <div class="header">
          <div class="lf">{{ item.slot_name }}</div>
          <div class="rt">{{ item.slot_code }}</div>
        </div>
        <div class="content">
          <div class="lf" @click="addSlotValue(item)">
            槽值取值：{{ item.total }}
          </div>
          <div class="rt">
            <el-tooltip
              content="编辑"
              placement="bottom"
              width="200"
              trigger="hover"
            >
              <img
                src="@/assets/images/edit.png"
                class="operation-icon"
                @click="addSlot('编辑', index)"
              />
            </el-tooltip>
            <el-dropdown
              trigger="click"
              @command="
                (e) => {
                  onTogle(e, item, index)
                }
              "
            >
              <el-tooltip
                :content="item.status == 1 ? '隐藏' : '显示'"
                placement="bottom"
                width="200"
                trigger="hover"
              >
                <img
                  v-if="item.status == 1"
                  src="@/assets/images/hide.png"
                  class="operation-icon"
                />
                <img
                  v-else
                  src="@/assets/images/show.png"
                  class="operation-icon"
                />
              </el-tooltip>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-for="item1 in statusOptions"
                  :key="item1.value"
                  :command="item1.value"
                  :disabled="item1.value == item.status"
                  >{{ item1.label }}</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
    </div>
    <el-pagination
      @current-change="handleCurrentChange"
      :current-page.sync="currentPage"
      :page-size="12"
      layout="total, prev, pager, next, jumper"
      :total="total"
      prev-text="上一页"
      next-text="下一页"
      v-if="total > 12"
    >
    </el-pagination>
    <el-dialog
      :close-on-click-modal="false"
      :title="titleText"
      :visible.sync="isOpened"
      width="800px"
      :before-close="closeAdd"
    >
      <el-form
        :model="slotForm"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm"
        label-position="left"
      >
        <el-form-item label="槽值名称：" prop="slot_name">
          <el-input
            v-model="slotForm.slot_name"
            :disabled="operationType == 'edit'"
            placeholder="请输入槽值名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="追问话术：" prop="query_text">
          <el-input
            v-model="slotForm.query_text"
            placeholder="请输入追问话术"
          ></el-input>
        </el-form-item>
        <upload-audio :audio.sync="slotForm.audio"></upload-audio>
        <el-form-item label="槽值提取方式：" prop="slot_rule">
          <el-radio-group v-model="slotForm.slot_rule" size="medium">
            <el-radio :label="1">无</el-radio>
            <el-radio :label="2">接口</el-radio>
            <el-radio :label="3">列举</el-radio>
            <el-radio :label="4">规则</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" round @click="closeAdd">取消</el-button>
        <el-button size="medium" round type="primary" @click="confirm"
          >提交</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      title="槽值取值"
      :visible.sync="slotVisible"
      width="800px"
      :before-close="closeDialog"
    >
      <aim-value
        labelName="槽值取值"
        :dataList="dataList"
        :searchInfo="slotSearch"
        @my-search="onSearch"
        @my-add="onAdd"
        @my-delete="onDelete"
        @my-input="onInput"
        @onSearchChange="onSearchChange"
      ></aim-value>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" round @click="closeDialog">取消</el-button>
        <el-button size="medium" round type="primary" @click="confirmSlot"
          >提交</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import { isSuccess, isEmpty } from '@/utils/index'
  import { ROBOT_TYPES, ROBOT_STATUS, ROBOT_TEXT } from '@/utils/const'
  import {
    getSlotList,
    addSlot,
    changeSlotStatus,
    getSlotValList,
    deleteSlotVal,
    addSlotVal,
  } from '@/api/aimManager'
  export default {
    components: {
      'aim-value': () => import('@/components/aimInfo/index.vue'),
      'upload-audio': () => import('@/components/uploadAudio/index.vue'),
    },
    data() {
      return {
        isOpened: false,
        titleText: '添加', // dialog的标题
        slotForm: {
          slot_name: '', // 槽值名称
          query_text: '', // 追问话术
          slot_rule: 1, // 槽值提取方式
          audio: '', // 音频地址
        }, // 槽值表单
        slotVisible: false, //槽值取值dialog
        currentPage: 1,
        total: 10,
        value: '',
        slotLists: [], // 槽值列表
        operationType: 'add', // 操作类型
        dataList: [], // 当前槽值列表
        slotSearch: '', // 槽值搜索
        currentItem: {}, //当前操作的
        statusOptions: ROBOT_TYPES,
        searchInfo: {
          keyword: '', //搜索关键词
          status: ROBOT_STATUS.show,
        },
      }
    },
    mounted() {
      this.getLists()
    },
    methods: {
      async getLists(type) {
        if (type == 'search') {
          this.currentPage = 1
        }
        const res = await getSlotList({
          page: this.currentPage,
          ...this.searchInfo,
          status: isEmpty(this.searchInfo.status)
            ? ROBOT_STATUS.show
            : this.searchInfo.status,
          pagesize: 12,
        })
        if (isSuccess(res.code)) {
          this.slotLists = res.data.list
          this.total = res.data.total
        }
      },
      /**
       * 点击添加或编辑槽值
       */
      addSlot(type, index) {
        this.titleText = type
        this.isOpened = true
        this.operationType = 'add'
        if (type == '编辑') {
          this.operationType = 'edit'
          this.slotForm = {
            ...this.slotLists[index],
            audio: this.slotLists[index].audio
              ? this.slotLists[index].audio.audio
              : '',
          }
        }
      },
      closeAdd() {
        this.isOpened = false
        this.slotForm = {
          slot_name: '',
          query_text: '',
          slot_rule: 1,
          audio: '',
        }
      },
      /**
      新增或修改
       */
      async confirm() {
        if (this.operationType == 'edit') {
          this.slotForm = {
            slot_code: this.slotForm.slot_code,
            slot_name: this.slotForm.slot_name,
            query_text: this.slotForm.query_text,
            slot_rule: this.slotForm.slot_rule,
            audio: this.slotForm.audio,
          }
        }
        const res = await addSlot(this.slotForm, this.operationType)
        if (isSuccess(res.code)) {
          this.$message({
            type: 'success',
            message: res.message,
          })
          await this.getLists()
          this.slotForm = {
            slot_name: '', // 槽值名称
            query_text: '', // 追问话术
            slot_rule: 1, // 槽值提取方式
            audio: '', // 音频地址
          }
          this.closeAdd()
        }
      },
      /**
       * 当切换隐藏/显示时
       */
      async onTogle(e, item, index) {
        const res = await changeSlotStatus({
          slot_code: item.slot_code,
          status: e,
        })
        if (isSuccess(res.code)) {
          this.$message({
            type: 'success',
            message: '切换成功',
          })
          await this.getLists()
          return
        }
      },

      async getSlotvallist(params) {
        const res = await getSlotValList(params)
        this.dataList = res.data
      },
      async addSlotValue(item) {
        await this.getSlotvallist({
          slot_code: item.slot_code,
        })
        this.currentItem = item

        this.slotVisible = true
      },

      closeDialog() {
        this.slotSearch = ''
        this.slotVisible = false
        this.getLists()
      },
      /**
       * 翻页
       */
      handleCurrentChange() {
        this.getLists()
      },
      onSearchChange(e) {
        this.slotSearch = e
      },
      onSearch(value) {
        this.slotSearch = value
        this.getSlotvallist({
          slot_code: this.currentItem.slot_code,
          slot_val: value,
        })
      },
      onAdd() {
        this.dataList.push({ slot_val: '', id: 0 })
      },
      async onDelete(index) {
        if (this.dataList[index].id == 0) {
          this.$message({ type: 'success', message: '删除成功' })
          this.dataList.splice(index, 1)
        } else {
          const res = await deleteSlotVal({
            id: this.dataList[index].id,
          })
          if (isSuccess(res.code)) {
            this.$message({ type: 'success', message: '删除成功' })
            this.dataList.splice(index, 1)
          }
        }
      },
      onInput(e, index) {
        this.dataList[index].slot_val = e
      },
      async confirmSlot() {
        if (isEmpty(this.dataList)) {
          this.$message.error('槽值不能为空')
          return
        }
        const res = await addSlotVal({
          slot_code: this.currentItem.slot_code,
          value: this.dataList,
        })
        if (isSuccess(res.code)) {
          this.$message({ type: 'success', message: res.message })
          this.slotVisible = false
          this.slotSearch = ''
          this.getLists()
          return
        }
        this.$message({ type: 'error', message: res.message })
      },
      resetSearchInfo() {
        this.searchInfo = {
          keyword: '', //搜索关键词
          status: ROBOT_STATUS.show,
        }
        this.getLists('search')
      },
    },
  }
</script>

<style lang="scss">
  .slot-list-container {
    .slot-lists {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 20px 20px;
    }

    .slot-container {
      padding: 0 26px 17px 26px;
      flex-shrink: 0;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      min-width: 400px;
      height: 170px;
      background: #ffffff;
      border: 1px solid #e6e6e6;
      box-shadow: 1px 4px 8px 0px rgba(0, 0, 0, 0.08);
      border-radius: 10px;
      box-sizing: border-box;
      .header,
      .content {
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #333;
      }
      .header {
        height: 54px;
        line-height: 54px;
        border-bottom: 1px solid #cccccc;
        .lf {
          font-size: 20px;
          font-weight: 700;
        }
        .rt {
          font-size: 18px;
        }
      }
      .content {
        .lf {
          cursor: pointer;
          font-size: 16px;
          text-decoration: underline;
        }
        .rt {
          display: flex;
        }
      }
    }
    @media screen and (max-width: 950px) {
      .slot-lists {
        grid-template-columns: 1fr;
      }
    }
    @media screen and (min-width: 950px) {
      .slot-lists {
        grid-template-columns: repeat(2, 1fr);
      }
      .slot-container {
        min-width: 300px;
      }
    }
    @media screen and (min-width: 1600px) {
      .slot-lists {
        grid-template-columns: repeat(3, 1fr);
      }
    }
    .el-button--primary {
      margin-bottom: 10px;
    }
    .el-button--primary:first-child {
      margin-right: 10px;
    }
    .el-form-item__label {
      padding: 0;
    }
    .el-empty {
      margin: 0 auto;
    }
    .el-dropdown {
      .operation-icon {
        margin-left: 24px;
      }
    }
  }
</style>
